import type { NavigateFunction } from 'react-router-dom';
import Logger from '../services/logger';
import {
  getPortalHomePathForProductType,
  type PortalProductUserType,
} from './portalAccessUtils';
import type { LoginUserType } from './userTypeUtils';

export type LoginTypeResult = {
  userType: LoginUserType;
  confidence: 'high' | 'medium' | 'low';
  source: string;
};

export function navigateUserToPortalAfterLogin(
  userTypeResult: LoginTypeResult,
  navigate: NavigateFunction,
  options?: { isMobile?: boolean }
): { ok: true } | { ok: false; error: string } {
  const { userType, confidence, source } = userTypeResult;

  if (userType === 'unknown' || (confidence === 'low' && source === 'undetermined')) {
    return {
      ok: false,
      error:
        'Your account is missing a valid user type (broker, shipper, or carrier). Please contact support.',
    };
  }

  const path = getPortalHomePathForProductType(userType as PortalProductUserType);
  const isMobile = options?.isMobile ?? (typeof window !== 'undefined' && window.innerWidth <= 768);

  if (isMobile) {
    Logger.debug('[Login] Mobile full-page redirect to portal home', { path, userType });
    window.location.href = path;
    return { ok: true };
  }

  Logger.debug('[Login] Navigating to portal home', { path, userType });
  navigate(path);
  return { ok: true };
}
